import { createClient } from '@/shared/api';
import START_HOLTER_STUDY_PROCESSING from '@/entities/study/api/mutations/startHolterStudyProcessing';
import type {
  StartHolterStudyProcessingMutation,
  StartHolterStudyProcessingMutationVariables,
} from '@/shared/api/generated/graphql';

export type StartHolterStudyProcessingResult = {
  isSuccess: boolean;
  message: string;
  isReady: boolean;
  processingStudyFids: string[];
  simultaneousStudyLimit: number;
};

// TODO(ts): typed as the HolterStudyProcessingInput GraphQL input once its server-side shape is documented
/**
 * Queues a study for holter processing on a worker. Runs the start mutation and returns its payload on success, throwing the server message otherwise.
 *
 * @param input - Mutation input identifying the study and processing options.
 * @returns A promise resolving to the startHolterStudyProcessing result.
 */
const handleStartHolterStudyProcessing = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    StartHolterStudyProcessingMutation,
    StartHolterStudyProcessingMutationVariables
  >({
    mutation: START_HOLTER_STUDY_PROCESSING,
    variables: { input },
  });
  if (result?.data?.startHolterStudyProcessing?.isSuccess) {
    return result?.data?.startHolterStudyProcessing;
  }
  throw new Error(result?.data?.startHolterStudyProcessing?.message);
};

export default handleStartHolterStudyProcessing;
